import { Controller, Get, UseGuards } from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiTags } from '@nestjs/swagger';
import { PrivilegiosService } from './privilegios.service';

@ApiTags('Privilegios')
@ApiBearerAuth()
@UseGuards(AuthGuard('jwt'))
@Controller({ path: 'privilegios', version: '1' })
export class PrivilegiosController {
  constructor(private readonly privilegiosService: PrivilegiosService) {}

  @Get()
  findAll() {
    return this.privilegiosService.findAll();
  }
}
